import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */

export default class extends Controller {
    static values = {
        // enable per form via data-form-show-preloader-value
        showPreloader: { type: Boolean, default: false },
    };

    connect() {
        // bind once, auto-listen for native submits
        this._onSubmit = this._onSubmit.bind(this);
        this.element.addEventListener('submit', this._onSubmit);
    }

    disconnect() {
        this.element.removeEventListener('submit', this._onSubmit);
    }

    _onSubmit() {
        if (!this.showPreloaderValue) {
            return;
        }

        // call your global function, if present
        if (typeof window.showPreloader === 'function') {
            try {
                window.showPreloader();
            } catch (e) {
                console.warn('showPreloader() threw an error:', e);
            }
        } else {
            console.warn('showPreloader() is not defined globally.');
        }
    }
}
